import { AreaConfig } from '../types';
import { NEIGHBORHOOD_COORDS } from './constants';

/** Neighborhoods. Adding one = one entry here (+ its listings use its id). */
export const AREAS: AreaConfig[] = [
  {
    id: 'neve-shamir',
    nameEn: 'Neve Shamir',
    nameHe: 'נווה שמיר',
    cityEn: 'Ramat Beit Shemesh',
    cityHe: 'רמת בית שמש',
    center: NEIGHBORHOOD_COORDS,
    zoom: 16,
  },
];

export const DEFAULT_AREA_ID = AREAS[0].id;

/** The area filter stays hidden while there is only one area. */
export const SHOW_AREA_FILTER = AREAS.length > 1;

export function getArea(id: string): AreaConfig | undefined {
  return AREAS.find((a) => a.id === id);
}
